import AppContext, {IAppContext, IAppV2Context} from "../../../componentsApp/context/AppContext";
import React, {useContext, useEffect} from "react";
import {Link} from "react-router-dom";

export default function ErrorPage(props: { page: string, code: number, fullPage: boolean, setPage: boolean }) {
  
  const appContextV2: IAppV2Context = useContext(AppContext) as IAppV2Context;
  const language: string = appContextV2.appSession.app.language;
  
  useEffect(() => {
    if(props.fullPage) {
      appContextV2.dispatchNavigation({type: "SET_PAGE", value: props.page});
    }
  }, []);
  
  return (
    <>
      <section className={`access-fail-40X__bg-3 ${props.fullPage ? "full-page" : "empty-page"}`}>
        <section className={"access-fail-40X"}>
          <article className={"access-fail-40X__number"}>
            {language === "FR" && <>ERREUR</>}
            {language !== "FR" && <>ERROR</>}
          </article>
          <article className={"access-fail-40X__message"}>
            {language === "FR" && <>Une erreur est survenue.<br/>N'hésitez pas à <Link to={"/contact"}>
              <button className={"btn--hollow modern-link"}>nous prévenir</button>
            </Link> si ce comportement persiste.</>}
            {language !== "FR" && <>It seems an error occured.<br/>Don't hesitate to contact us if this behaviour persists -</>}
          </article>
        </section>
      </section>
    </>
  );
}